  <po-page-default p-title="SonarQube">
    <po-tabs class="menu-tabs">
      <po-tab [p-hide]="!isFullAccess" p-label="Dashboard" [p-active]="isFullAccess" (p-click)="onTabClick('dashboard')">
        <app-sonar-extractor-dashboard *ngIf="tabLoaded.dashboard"></app-sonar-extractor-dashboard>
      </po-tab>
      <po-tab p-label="Data Studio" [p-active]="!isFullAccess" (p-click)="onTabClick('datastudio')">
        <app-sonar-extractor-datastudio *ngIf="tabLoaded.datastudio"></app-sonar-extractor-datastudio>
      </po-tab>
      <po-tab [p-hide]="!isFullAccess" p-label="Extrações" [p-active]="false" (p-click)="onTabClick('runs')">
        <app-sonar-extractor-runs *ngIf="tabLoaded.runs"></app-sonar-extractor-runs>
      </po-tab>
      <po-tab [p-hide]="!isFullAccess" p-label="Releases" [p-active]="false" (p-click)="onTabClick('releases')">
        <app-sonar-extractor-releases *ngIf="tabLoaded.releases"></app-sonar-extractor-releases>
      </po-tab>
      <po-tab [p-hide]="!isFullAccess" p-label="Projetos" [p-active]="false" (p-click)="onTabClick('projects')">
        <app-sonar-extractor-projects *ngIf="tabLoaded.projects"></app-sonar-extractor-projects>
      </po-tab>
      <po-tab p-label="Issues" [p-active]="!isFullAccess" (p-click)="onTabClick('issues')">
        <app-sonar-extractor-issues *ngIf="tabLoaded.issues"></app-sonar-extractor-issues>
      </po-tab>
    </po-tabs>
  </po-page-default>